import React from "react";

const BlurModal = (props) => {
    const hide = {display:'none'};
    const show = {
        width:' 100%',
        height: '100%',
        position: 'fixed',
        display: 'block',
        top: '0',
        left: '0',
        opacity: '1',
        zIndex: '1'}

    return (
        <div style={props.show?show:hide}>
            <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh", width: "100vw", backdropFilter: "blur(8px)" ,zIndex: '60'}}>
                <div className="col-lg-5 m-5 bg-light shadow-lg p-3 rounded text-center">
                    <h1>{props.title}</h1>
                    <p>{props.message}</p>
                    <button className="btn  shadow text-white " style={{backgroundColor:'rgb(82,28,62)'}} onClick={()=>{props.hide(false);}}>Aceptar</button>
                </div>
            </div>
        </div>
    );
}

export default BlurModal;